import React from 'react';
import { connect } from 'react-redux';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import styles from '../region-entity-banner.module.scss';
import closeIcon from '../../../public/img/close-icon.svg';
import {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
} from '../../actions/ui';
import { EntityTable } from '../region-entity-table';

const EntityBanner = ({ entity, comparing, onCloseClicked }) => {
  return (
    <div
      className={`${styles.banner} ${styles.entityBanner}`}
      data-comparing={comparing}
    >
      <button className={styles.closeButton} onClick={onCloseClicked}>
        <img src={closeIcon} alt="" style={{ height: 10, width: 10 }} />
      </button>
      <h2 className={styles.mapBannerHeading}>{entity.name}</h2>
      {!comparing && <EntityTable entity={entity} />}
    </div>
  );
};

const mapDispatchToProps = {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
};

const mapStateToProps = (state, props) => ({
  isMobile: selectors.getIsMobile(state),
});

EntityBanner.propTypes = {
  entity: PropTypes.object,
  setActiveRegion: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntityBanner);



// WEBPACK FOOTER //
// ./src/components/entity-info/entity-banner.js